<template>
  <div class="index">
    <div class="top">
      <search></search>
      <brands></brands>
      <price></price>
    </div>
    <div class="bottom">
      <tab></tab>
    </div>

    <footer>
      <foot />
    </footer>
  </div>
</template>

<script>
import search from "../components/search";
import brands from "../components/brands";
import price from "../components/price";
import tab from "../components/tab";
import foot from "../components/footer.vue";

// import {mapState} from 'vuex';

export default {
  name: "index",
  data() {
    return {};
  },

  components: {
    search,
    brands,
    price,
    tab,
    foot,
  },
  created() {
    //  console.log(123);
  },
};
</script>

<style scoped lang="less">
.tabs {
  display: flex;
  height: 32px;
  line-height: 32px;
  -webkit-box-pack: justify;
  justify-content: space-between;
  background: #f5f7fa;
  .tabs-item {
    transition: color 0.3s;
    cursor: pointer;
    font-size: 14px;
    -webkit-box-flex: 1;
    flex: 1;
    text-align: center;
  }
  .tabs-item:hover {
    font-weight: 700;
    color: #ff9900;
  }
  .tabact {
    color: #ff9900;
    font-weight: 700;
    border-bottom: 2px solid #ff9900;
  }
}
footer {
  clear: both;
  position: fixed;
  width: 100%;

  bottom: 0;
  left: 0;
}
</style>
